module.exports = "<div class=\"sis-login__form-error\">\n    {{resolvedMessage}}\n</div>\n";